/**
 * Reads what the surrounding page told us, once, before React starts.
 *
 * Three ways in: an embed inside a hotel page (public key on the query string), a fullpage link,
 * and a continuation link from a mail. The continuation token is stripped from the URL right
 * away so it does not end up in the browser history, a bookmark or a referrer header.
 */

export type LaunchMode = "fullpage" | "embed";

let publicKey = "";
let continuationToken: string | null = null;
let language = "de";
let mode: LaunchMode = "fullpage";

function readInitial() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);

  mode = window.location.pathname.startsWith("/embed") || params.get("mode") === "embed" ? "embed" : "fullpage";
  publicKey = params.get("k") ?? params.get("hotel") ?? "";

  const continuation = /^\/f\/([^/]+)$/.exec(window.location.pathname);
  if (continuation?.[1]) {
    continuationToken = decodeURIComponent(continuation[1]);
    window.history.replaceState({}, "", mode === "embed" ? "/embed" : "/");
  }

  const requested = params.get("lang");
  if (requested === "de" || requested === "en") language = requested;
  else if (navigator.language.startsWith("en")) language = "en";
}

readInitial();

export function launchMode(): LaunchMode {
  return mode;
}

export function launchPublicKey(): string {
  return publicKey;
}

export function launchLanguage(): string {
  return language;
}

/** One-shot: the token must not survive in memory after it has been exchanged. */
export function consumeContinuationToken(): string | null {
  const value = continuationToken;
  continuationToken = null;
  return value;
}
